export var buildQueryString = function (params) {
    if (!params)
        return "";
    // @ts-ignore
    return Object.entries(params)
        .filter(function (_a) {
        var key = _a[0], value = _a[1];
        return value !== undefined && value !== null && value !== "";
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        if (Array.isArray(value)) {
            return value
                .map(function (item) { return "".concat(key, "=").concat(encodeURIComponent(item)); })
                .join("&");
        }
        return "".concat(key, "=").concat(encodeURIComponent(value));
    })
        .join("&");
};
